module.exports = __webpack_public_path__ + "img/gift-08-c1.caf4bb78.png";